import { ref } from "vue";

export const wechatServiceOpen = ref(false);

export function openWeChatService() {
  wechatServiceOpen.value = true;
}

export function closeWeChatService() {
  wechatServiceOpen.value = false;
}
